import { render } from "./ExperienceWidget.vue?vue&type=template&id=0d1ea5c9"
import script from "./ExperienceWidget.vue?vue&type=script&lang=js"
export * from "./ExperienceWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__